import React from "react"

const GrayLine = ({ marginTop = "16px" }) => {
  return (
    <table
      border="0"
      cellSpacing="0"
      cellPadding="0"
      style={{ width: "100%", marginTop: marginTop }}
    >
      <tbody>
        <tr>
          <td
            style={{
              borderBottom: "4px solid #616161",
              marginTop: marginTop,
              padding: "0px"
            }}
          ></td>
        </tr>
      </tbody>
    </table>
  )
}

export default GrayLine
